module.exports = __webpack_public_path__ + "images/emoji_3_color37942e6bf0fc9515f3424e00a0d53d7e.svg";